import { GridContainer, GridContainerName } from "../../../interfaces/IGridSettings";
import AffectedCustomersContainer from "../AffectedEntitiesComponents/AffectedEntitiesContainer";
import AlertContainer from "../AlertComponents/AlertContainer";
import DetailsContainer from "../DetailsComponents/DetailsContainer";
import PostContainer from "../PostComponents/PostContainer";
import DocumentContainer from "../DocumentComponents/DocumentContainer";
import { EventDto } from "../../../interfaces/IEvent";
import { Grid } from "@mui/material";
import AssignmentContainer from "../AssignmentComponents/AssignmentContainer";



interface GenericContainersProps {
    container: GridContainer;
    index: number;
    viewEvent: EventDto;
    handleGetEvent: (eventId: string | undefined) => void;
};

export default function GenericContainers ({ container, index, viewEvent, handleGetEvent }: GenericContainersProps) {
    const containers: any = {
        [GridContainerName.detailsContainer]: <DetailsContainer key={index} viewEvent={viewEvent} onUpdateEventView={handleGetEvent} />,
        [GridContainerName.affectedCustomersContainer]: <AffectedCustomersContainer key={index} viewEvent={viewEvent} />,
        [GridContainerName.alertContainer]: <AlertContainer key={index} viewEvent={viewEvent} onUpdateEventView={handleGetEvent} />,
        [GridContainerName.postContainer]: <PostContainer key={index} eventId={viewEvent?.id} eventPosts={viewEvent?.eventPosts} onUpdateEventView={handleGetEvent} />,
        [GridContainerName.documentContainer]: <DocumentContainer key={index} viewEvent={viewEvent} />,
        [GridContainerName.assignmentContainer]: <AssignmentContainer key={index} viewEvent={viewEvent} onUpdateEventView={(eventId: string) => Promise.resolve(handleGetEvent(eventId))} />
    }

    return (containers[container.name] ? <Grid key={index} size={container.width}>
                {containers[container.name]}
            </Grid> : null);
};